import { RefObject } from 'react';
import { ParsedEmbedSnippet } from './parseEmbedSnippet.ts';
import { triggerOutbrainRefresh } from './outbrainRefresher.ts';

function isOutbrainSnippet(parsed: ParsedEmbedSnippet): boolean {
  const htmlHasOutbrainClass = /class="[^"]*\bOUTBRAIN\b[^"]*"/.test(
    parsed.containerHtml
  );
  const scriptSrcContainsOutbrain = parsed.scriptSrcs.some((src) =>
    {return src.toLowerCase().includes('outbrain')}
  );
  return htmlHasOutbrainClass || scriptSrcContainsOutbrain;
}

const noop = () => {};

export function createOnLoadCallback(
  parsed: ParsedEmbedSnippet,
  containerRef: RefObject<HTMLDivElement | null>
): () => void {
  if (isOutbrainSnippet(parsed)) {
    return () => {return triggerOutbrainRefresh(containerRef)};
  }
  return noop;
}
